export default __webpack_public_path__ + "static/media/EM0380.34I-22662_-15278_0.b440ccc7.jpg";